import { render, staticRenderFns } from "./HeadDeptRatingDirectionsIndex.vue?vue&type=template&id=8065a0f4"
import script from "./HeadDeptRatingDirectionsIndex.vue?vue&type=script&lang=js"
export * from "./HeadDeptRatingDirectionsIndex.vue?vue&type=script&lang=js"
import style0 from "./HeadDeptRatingDirectionsIndex.vue?vue&type=style&index=0&id=8065a0f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports